'use client';
import { env } from '@/env';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { DATADOG_APPLICATION_ID, DATADOG_CLIENT_TOKEN } from './constants';
import { beforeSend } from './utils';

function initDatadog() {
  if (!datadogRum.getInitConfiguration()) {
    datadogRum.init({
      applicationId: DATADOG_APPLICATION_ID,
      clientToken: DATADOG_CLIENT_TOKEN,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.eu',
      service: 'pigello-frontend',
      env: env.NEXT_PUBLIC_CLIENT_TYPE,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: env.NEXT_PUBLIC_COMMIT_HASH,
      sessionSampleRate: 50,
      sessionReplaySampleRate: 50,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      traceSampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      // Specify URLs to propagate trace headers for connection between RUM and backend trace
      allowedTracingUrls: [
        {
          match: window.location.host,
          propagatorTypes: ['datadog'],
        },
        {
          match: env.NEXT_PUBLIC_BASE_BACKEND_URL,
          propagatorTypes: ['datadog'],
        },
        {
          match: env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL,
          propagatorTypes: ['datadog'],
        },
        {
          match: env.NEXT_PUBLIC_BASE_DASHBOARD_URL,
          propagatorTypes: ['datadog'],
        },
        {
          match: env.NEXT_PUBLIC_INTEGRATION_MONITOR_URL,
          propagatorTypes: ['datadog'],
        },
        {
          match: env.NEXT_PUBLIC_BASE_ADMIN_URL,
          propagatorTypes: ['datadog'],
        },
      ],
      beforeSend: beforeSend,
    });
  }
}
export function DatadogInit() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    initDatadog();
    return () => {
      datadogRum.clearUser();
    };
  }, []);
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
